import * as React from 'react';
import { ISubCardIndicatorProps } from './types';
import { CARD_CLASS, CARD_CONTROL_CLASS } from '../../../constants';
import { Tooltip } from 'kui';
import { TITLE_SUBCARD } from '../../../wording';
import { escape } from 'underscore';

export function SubCardIndicator({
    epicName,
    onClick,
}: ISubCardIndicatorProps) {
    const Icon = require('!!@svgr/webpack!./subCardIcon.svg').default;
    const className = CARD_CLASS + '__count-indicator';

    return <Tooltip
        isNoWrap
        isNoEvents
        value={TITLE_SUBCARD + escape(epicName)}
    >
        <div
            className={`${className} ${className}--action ${CARD_CONTROL_CLASS}`}
            onClick={onClick}
        >
            <Icon className={CARD_CLASS + '__count-icon'} />
        </div>
    </Tooltip>;
}
